module.exports = __webpack_public_path__ + "img/Still-Thinking-2.07cd4221.png";